import { render, staticRenderFns } from "./ModalNotRegisteredWhitelisted.vue?vue&type=template&id=4bef84f2&"
import script from "./ModalNotRegisteredWhitelisted.vue?vue&type=script&lang=js&"
export * from "./ModalNotRegisteredWhitelisted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports